/**
 * Row text for the one client picker. Pure. The policy segment is
 * `matchedPolicyNumber` (policy-leg rows) or the count; an unknown count
 * yields no segment, never "0 policies".
 */

export function policyCountText(n: number): string {
  return n === 1 ? "1 policy" : `${n} policies`;
}

export interface ClientRowDetailInput {
  city?: string;
  state?: string;
  postalCode?: string;
  policyCount?: number;
  matchedPolicyNumber?: string;
}

/** Ordered segments: `[ "City, ST 99301", "2 policies" | "POL-123" ]`. */
export function clientRowDetail(o: ClientRowDetailInput): string[] {
  const address = [
    o.city,
    o.state && `, ${o.state}`,
    o.postalCode && ` ${o.postalCode}`,
  ]
    .filter(Boolean)
    .join("");

  const matched = o.matchedPolicyNumber?.trim();
  const policy = matched
    ? matched
    : typeof o.policyCount === "number" && Number.isFinite(o.policyCount)
      ? policyCountText(o.policyCount)
      : "";

  return [address, policy].filter((segment) => segment !== "");
}
